import { render } from "./boards.vue?vue&type=template&id=315c49a9&scoped=true"
import script from "./boards.vue?vue&type=script&lang=js"
export * from "./boards.vue?vue&type=script&lang=js"

import "./boards.vue?vue&type=style&index=0&id=315c49a9&scoped=true&lang=css"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315c49a9"]])

export default __exports__